import React, { JSX } from 'react';
import { observer } from 'mobx-react';
import PaxRoomSelectionController from './PaxRoomSelectionController';
import { Label } from 'reactstrap';
import { range } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import Keys from '../../Translations/generated/pax-room-selection.en.json.keys';
import { ReactSelectOption, Select } from '@ibe/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const ChildAgePicker = observer(
  ({
    roomIndex,
    childIndex,
    childAgePlaceholder,
    maxChildAge,
    state,
    validateChildrenSelection,
    paxHasError,
    menuPortalTarget,
    onChange,
    newAgeSelect
  }: {
    roomIndex: number;
    childIndex: number;
    childAgePlaceholder?: string;
    maxChildAge?: number;
    state: PaxRoomSelectionController;
    validateChildrenSelection?: () => boolean;
    paxHasError?: boolean;
    menuPortalTarget?: HTMLElement;
    onChange?: (roomIndex: number, childIndex: number, newValue: ReactSelectOption) => void;
    newAgeSelect?: boolean;
  }): JSX.Element => {
    const { t } = useTranslation('pax-room-selection');
    const finalMaxChildAge = maxChildAge ? maxChildAge + 1 : state.defaultChildAgeLimit;

    const selectElemId = 'childAgePicker' + (childIndex + 1);

    return (
      <>
        <Label for={selectElemId} className="paxRoomSelection__child-age-picker__label">{`${t(
          Keys.ageCapitalized
        )} - ${t(Keys.child)} ${childIndex + 1}`}</Label>
        {newAgeSelect ? (
          <div className="child-age-picker-native-container">
            <select
              id={selectElemId}
              className="child-age-picker-native"
              defaultValue={
                state.rooms[roomIndex].childrenAges.length > childIndex &&
                !Number.isNaN(state.rooms[roomIndex].childrenAges[childIndex])
                  ? state.rooms[roomIndex].childrenAges[childIndex]
                  : undefined
              }
              onChange={({ target: { value } }) => {
                const val = state.getChildAgeOption(Number(value));
                onChange
                  ? onChange(roomIndex, childIndex, val)
                  : state.setChildAgeForRoom(roomIndex, childIndex, val);
              }}
            >
              {range(0, finalMaxChildAge).map(val => {
                return (
                  <option key={val} value={val}>
                    {val}
                  </option>
                );
              })}
            </select>
            <FontAwesomeIcon
              icon={faChevronDown}
              className="child-age-picker-native-icon px-2"
              aria-hidden={true}
            />
          </div>
        ) : (
          <Select
            placeholder={childAgePlaceholder}
            options={range(0, finalMaxChildAge).map(val => {
              return state.getChildAgeOption(val);
            })}
            selectedOption={
              state.rooms[roomIndex].childrenAges.length > childIndex &&
              !Number.isNaN(state.rooms[roomIndex].childrenAges[childIndex])
                ? state.getSelectedChildAgeOption(state.rooms[roomIndex].childrenAges[childIndex])
                : null
            }
            getLabel={(option): string => (option ? option.label : '')}
            getValue={(option): string => (option ? option.value : '')}
            onChange={(val): void =>
              onChange
                ? onChange(roomIndex, childIndex, val)
                : state.setChildAgeForRoom(roomIndex, childIndex, val)
            }
            isSearchable={false}
            menuPlacement={'auto'}
            menuPortalTarget={menuPortalTarget}
          />
        )}
      </>
    );
  }
);

export default ChildAgePicker;
